import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PageHeader1 from "../../components/common/PageHeader1";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
  Switch,
} from "@mui/material";
import { fetchCategory } from "../../Redux/Reducers/CategoryReducer";
import axios from "axios";
import { Button } from "react-bootstrap";
import { usePermissions } from "../../context/AuthContext";
import toast from "react-hot-toast";

function CategoryList() {
  const { can } = usePermissions();
  const dispatch = useDispatch();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [openFeaturedDialog, setOpenFeaturedDialog] = useState(false);
  const [selectedFeaturedData, setSelectedFeaturedData] = useState(null);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const category = useSelector((state) => state.CategoryReducer.category);
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });
  const pagination = useSelector((state) => state?.CategoryReducer?.pagination) || {};
  useEffect(() => {
    const { page, pageSize } = paginationModel;
    dispatch(fetchCategory({ page: page + 1, limit: pageSize }));
  }, [paginationModel, dispatch]);

  const rows = Array.isArray(category) ? category?.map((item, index) => {
    return {
      id: paginationModel.page * paginationModel.pageSize + index + 1,
      categoryName: item?.categoryName ?? '-',
      createdAt: item?.createdAt
        ? new Date(item?.createdAt).toLocaleString()
        : "",
      updatedAt: item?.updatedAt
        ? new Date(item?.updatedAt).toLocaleString()
        : "",
      isFeatured: item?.isFeatured ?? false,
      _id: item?._id
    };
  }) : [];

  function deleteCategory(id) {
    const token = localStorage.getItem("vedhvidhi-admin-token");

    axios.delete(`${process.env.REACT_APP_BASEURL}/admin/category/${id}`, {
      headers: {
        Authorization: token,
      }
    })
      .then(response => {
        if (response.data.status) {
          const { page, pageSize } = paginationModel;
          dispatch(fetchCategory({ page: page + 1, limit: pageSize }));
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  const handleClickOpen = (id) => {
    setSelectedUserId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUserId(null);
  };

  const handleDelete = () => {
    if (selectedUserId) {
      deleteCategory(selectedUserId);
    }
    handleClose();
  };

  const handleFeaturedToggle = (categoryId, currentStatus, categoryName) => {
    setSelectedFeaturedData({
      categoryId,
      currentStatus,
      categoryName,
    });
    setOpenFeaturedDialog(true);
  };

  const handleCloseFeaturedDialog = () => {
    setOpenFeaturedDialog(false);
    setSelectedFeaturedData(null);
  };

  const handleConfirmFeaturedToggle = async () => {
    if (!selectedFeaturedData) return;

    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      const response = await axios.patch(
        `${process.env.REACT_APP_BASEURL}/admin/category/featured/${selectedFeaturedData.categoryId}`,
        {
          isFeatured: !selectedFeaturedData.currentStatus,
        },
        { headers: { Authorization: token } }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Featured status updated successfully!");
        const { page, pageSize } = paginationModel;
        dispatch(fetchCategory({ page: page + 1, limit: pageSize }));
      }
    } catch (error) {
      console.error("Error updating featured status:", error);
      toast.error(error.response?.data?.message || "Failed to update featured status");
    } finally {
      handleCloseFeaturedDialog();
    }
  };

  const columns = [
    { field: "id", headerName: "S.No", width: 50 },
    { field: "categoryName", headerName: "Category Name", width: 200 },
    {
      field: "isFeatured",
      headerName: "Featured",
      width: 120,
      renderCell: ({ row }) => (
        <Switch
          checked={!!row.isFeatured}
          onChange={() => handleFeaturedToggle(row._id, row.isFeatured, row.categoryName)}
          disabled={!can('category_management:edit')}
          color="primary"
        />
      ),
    },
    { field: "createdAt", headerName: "Created At", width: 220 },
    { field: "updatedAt", headerName: "Updated At", width: 220 },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: ({ row }) => (
        <div>
          {can('category_management:edit') && (
            <Tooltip title="Edit Category">
              <IconButton
                component={Link}
                to={process.env.PUBLIC_URL + `/category-edit/${row._id}`}
              >
                <i className="icofont-edit text-info"></i>
              </IconButton>
            </Tooltip>
          )}
          {can('category_management:delete') && (
            <Tooltip title="Delete Category">
              <IconButton onClick={() => handleClickOpen(row._id)}>
                <i className="icofont-ui-delete text-danger"></i>
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="body d-flex py-1">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Category List"
          righttitle="Add Category"
          link="/category-add"
          routebutton={can('category_management:add')}
        />
        <div className="row g-0 mb-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div
                  id="myDataTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <Box sx={{ width: 1 }}>
                        <Box sx={{ height: 400 }}>
                          <DataGrid
                            columns={columns}
                            rows={rows}
                            getRowId={(row) => row._id}
                            disableColumnFilter
                            disableDensitySelector
                            slots={{ toolbar: GridToolbar }}
                            filterModel={filterModel}
                            onFilterModelChange={(newModel) =>
                              setFilterModel(newModel)
                            }
                            slotProps={{ toolbar: { showQuickFilter: true } }}
                            columnVisibilityModel={columnVisibilityModel}
                            onColumnVisibilityModelChange={(newModel) =>
                              setColumnVisibilityModel(newModel)
                            }
                            disableRowSelectionOnClick
                            paginationMode="server"
                            rowCount={pagination?.totalDocs || 0}
                            pageSizeOptions={[10, 25, 50, 100]}
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                          />
                        </Box>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="secondary">
              Cancel
            </Button>
            <Button onClick={handleDelete} variant="danger" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openFeaturedDialog}
          onClose={handleCloseFeaturedDialog}
          aria-labelledby="featured-dialog-title"
          aria-describedby="featured-dialog-description">
          <DialogTitle id="featured-dialog-title">{"Featured Status Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="featured-dialog-description">
              {selectedFeaturedData && (
                <>
                  Are you sure you want to {selectedFeaturedData.currentStatus ? "remove" : "mark"} this category as{" "}
                  {selectedFeaturedData.currentStatus ? "non-featured" : "featured"}?
                  {selectedFeaturedData.categoryName && (
                    <strong> ({selectedFeaturedData.categoryName})</strong>
                  )}
                </>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseFeaturedDialog} variant="secondary">
              Cancel
            </Button>
            <Button onClick={handleConfirmFeaturedToggle} variant="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default CategoryList;